import { QueryState } from 'common/enums';
import { Nullable } from 'common/utils/Nullable';

export interface IDeleteRequirementState {
  state: QueryState;
  error: Nullable<string>;
  accessToken: string | undefined;
}

export const DeleteRequirementEmptyState: IDeleteRequirementState = {
  state: QueryState.UNDEFINED,
  error: null,
  accessToken: undefined
};
